import React from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';
import EventNewsDetails from '../screens/EventNewsDetails';
import EventNotifications from '../screens/EventNotifications';
import NotificationsRedirector from '../screens/NotificationsRedirector';

export default props => (
    <Switch>
        <Route path={`${props.match.path}`} exact component={EventNotifications} />
        <Route path={`${props.match.path}/news/:articleId`} exact component={EventNewsDetails} />
        <Redirect from={`${props.match.path}/news`} to={`${props.match.path}`} />
        <Route path={`${props.match.path}/:notificationId`} component={NotificationsRedirector} />
        <Redirect to={`${props.match.path}`} />
    </Switch>
);
